<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-video4_2-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-video4_2-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.43894655988764;"
    data-aspect-ratio="0.439"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-video4_2-xs-img"
      class="g-video4_2-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video4_2-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.466%;margin-top:-8.5px;left:68.4255%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-boxtext g-aiAbs"
      style="top:36.3129%;left:49.7639%;margin-left:-25.303%;width:50.6061%;"
    >
      <p class="g-pstyle1">Vehicle moves forward.</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:53.2774%;margin-top:-8.5px;left:73.1735%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-boxtext g-aiAbs"
      style="top:87.1242%;left:49.2179%;margin-left:-27.8788%;width:55.7576%;"
    >
      <p class="g-pstyle1">
        ICE agent 1 and the vehicle appear to make contact as Good pulls away
        from him.
      </p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-video4_2-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.37292328636339;"
    data-aspect-ratio="1.373"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-video4_2-sm-img"
      class="g-video4_2-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video4_2-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:4.9909%;margin-top:-8.5px;left:42.8014%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:5.2601%;margin-top:-8.5px;left:87.177%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-boxtext g-aiAbs"
      style="top:73.761%;left:27.6566%;margin-left:-16.3725%;width:32.7451%;"
    >
      <p class="g-pstyle1">Vehicle moves forward.</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-boxtext g-aiAbs"
      style="top:73.761%;left:71.6763%;margin-left:-18.0392%;width:36.0784%;"
    >
      <p class="g-pstyle1">
        ICE agent 1 and the vehicle appear to make contact as Good pulls away
        from him.
      </p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-video4_2-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.77433599098022;"
    data-aspect-ratio="1.774"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-video4_2-md-img"
      class="g-video4_2-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video4_2-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:4.7376%;margin-top:-9.6px;left:43.6972%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:4.7376%;margin-top:-9.6px;left:77.9874%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-boxtext g-aiAbs"
      style="top:73.393%;left:32.7347%;margin-left:-12.6515%;width:25.303%;"
    >
      <p class="g-pstyle1">Vehicle moves forward.</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-boxtext g-aiAbs"
      style="top:73.393%;left:66.7498%;margin-left:-13.9394%;width:27.8788%;"
    >
      <p class="g-pstyle1">
        ICE agent 1 and the vehicle appear to make contact as Good pulls away
        from him.
      </p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-video4_2-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 2.50694034255855;"
    data-aspect-ratio="2.507"
    data-min-width="930"
  >
    <div
      id="g-video4_2-lg-img"
      class="g-video4_2-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video4_2-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:4.7504%;margin-top:-9.6px;left:46.2049%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:4.7504%;margin-top:-9.6px;left:70.5399%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-boxtext g-aiAbs"
      style="top:73.5908%;left:37.8874%;margin-left:-8.9785%;width:17.957%;"
    >
      <p class="g-pstyle1">Vehicle moves forward.</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-boxtext g-aiAbs"
      style="top:73.5908%;left:62.0272%;margin-left:-9.8925%;width:19.7849%;"
    >
      <p class="g-pstyle1">
        ICE agent 1 and the vehicle appear to make contact as Good pulls away
        from him.
      </p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-09 18:05 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-09 18:05 -->
<!-- ai file: video4_2.ai -->
<style lang="scss">
  #g-video4_2-box {
    container-type: inline-size;
    container-name: g-video4_2-box;
  }
  #g-video4_2-box,
  #g-video4_2-box .g-artboard {
    margin: 0 auto;
  }
  #g-video4_2-box p {
    margin: 0;
  }
  #g-video4_2-box .g-aiAbs {
    position: absolute;
  }
  #g-video4_2-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-video4_2-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-video4_2-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-video4_2-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-video4_2-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-video4_2-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-video4_2-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-video4_2-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-video4_2-lg {
        display: block !important;
      }
    }
  }
  #g-video4_2-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video4_2-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-video4_2-xs .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-video4_2-xs .g-pstyle1 {
    font-weight: 700;
    text-align: center;
  }
  #g-video4_2-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video4_2-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-video4_2-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-video4_2-sm .g-pstyle1 {
    font-weight: 700;
    text-align: center;
  }
  #g-video4_2-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video4_2-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-video4_2-md .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-video4_2-md .g-pstyle1 {
    font-weight: 700;
    text-align: center;
  }
  #g-video4_2-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video4_2-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-video4_2-lg .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-video4_2-lg .g-pstyle1 {
    font-weight: 700;
    text-align: center;
  }

  /* Custom CSS */
  @mixin shadow-roquefort($clr) {
    text-shadow:
      0 0 2px rgba($clr, 1),
      0 0 2px rgba($clr, 0.8),
      0 0 2px rgba($clr, 0.5);
  }
  .g-boxtext {
    background-color: rgba(34, 34, 34, 0.768627451);
    border-radius: 2px;
    padding: 10px 9px;
  }
  .g-timestamp {
    background-color: rgba(34, 34, 34);
    padding: 1px 3px;
  }
  .g-yellowtext {
    @include shadow-roquefort(#000000);
  }
</style>
